function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #rateStar2 .cls-1,\n      #rateStar2 .cls-2 {\n        /* fill: transparent; */\n        fill: #f2ca00;\n        fill-opacity: 1;\n        transition: fill .25s ease, fill-opacity .25s ease;\n      }\n\n      /* #rateStar2:hover .cls-1,\n      #rateStar2:hover .cls-2 {\n        fill-opacity: 1;\n      } */\n\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  className: "cls-G-1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f2ca00",
  d: "M15.86,3l3.77,7.39.31.61.67.09,8.31,1.15-6,5.72-.5.48.12.69L24,27.16l-7.5-3.81-.6-.3-.59.3L7.86,27.22l1.39-8.09.12-.69L8.86,18l-6-5.67,8.31-1.21.67-.1.31-.6L15.86,3m0-2.88L11,9.79,0,11.38l8,7.53L6.13,29.58l9.8-5.07,9.83,5L23.85,18.86l7.92-7.58-11-1.52L15.85.08Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "6.47 28.95 15.8 24.2 15.88 1.01 11.19 10.2 0.77 11.64 8.29 18.83 6.47 28.95"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "25.14 28.77 15.8 24.02 15.73 0.83 20.42 10.02 30.84 11.47 23.32 18.66 25.14 28.77"
})));

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 34.58",
    id: "rateStar2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.a1b9acd5.svg";
export { ForwardRef as ReactComponent };